import {connect} from 'react-redux';
import {GelPipette as Component} from './GelPipette';
import {
  showModal,
  setGelLane,
  setVol,
  setTargetList,
  makeGelImgConfig,
  setLastDrop,
  setGelActiveLane
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,

    pipetteId: ownProps.pipetteId,
    gelId: ownProps.gelId,
    type:state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.pipetteId - 1].type,
    volume:state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.pipetteId - 1].volume,
    minVol:state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.pipetteId - 1].minVol,
    maxVol:state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.pipetteId - 1].maxVol,
    volChange:state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.pipetteId - 1].volChange,
    lanes:  state.notebook.protocolSection.scene.apparatus.agaroseGel[ownProps.gelId - 1].lanes,
    activeLane:  state.notebook.protocolSection.scene.apparatus.agaroseGel[ownProps.gelId - 1].activeLane,
    containsBuffer:state.notebook.protocolSection.scene.apparatus.gelBoxes[ownProps.gelBoxId - 1].containsBuffer,
    imgConfig:  state.notebook.protocolSection.scene.apparatus.agaroseGel[ownProps.gelId - 1].laneImgConfig,
    plungerPosition:state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.pipetteId - 1].plungerPosition,
  

  }
}

function mapDispatchToProps(dispatch) {
  return {

    showModal: (data) =>{
      dispatch(showModal(data))
    },
    setGelLane: (data) =>{
      dispatch(setGelLane(data))
    },
    setVol: (data) =>{
      dispatch(setVol(data))
    },
    setTargetList: (data) =>{
      dispatch(setTargetList(data))
    },
    makeGelImgConfig: (data) =>{
      dispatch(makeGelImgConfig(data))
    },
    setLastDrop: (data) =>{
      dispatch(setLastDrop(data))
    },
    setGelActiveLane: (data) =>{
      dispatch(setGelActiveLane(data))
    },
 
  }
}

export const GelPipette = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);


// previous 

// const mapStateToProps = (state, ownProps) => {
//   return {
//     pipetteId: ownProps.pipetteId,
//     gelId: ownProps.gelId,
//     type: state.pipette.pipettes[ownProps.pipetteId - 1].type,
//     volume: state.pipette.pipettes[ownProps.pipetteId - 1].volume,
//     minVol: state.pipette.pipettes[ownProps.pipetteId - 1].minVol,
//     maxVol: state.pipette.pipettes[ownProps.pipetteId - 1].maxVol,
//     volChange: state.pipette.pipettes[ownProps.pipetteId - 1].volChange,
//     lanes: state.gel.gels[ownProps.gelId - 1].lanes,
//     activeLane: state.gel.gels[ownProps.gelId - 1].activeLane,
//     containsBuffer: state.gelBox.gelBoxes[ownProps.gelBoxId - 1].containsBuffer,
//     imgConfig: state.gel.gels[ownProps.gelId - 1].laneImgConfig,
//     plungerPosition:
//       state.pipette.pipettes[ownProps.pipetteId - 1].plungerPosition,
//   };
// };

// export default connect(
//   mapStateToProps,
//   {
//     showModal,
//     setGelLane,
//     setVol,
//     setTargetList,
//     makeGelImgConfig,
//     setLastDrop,
//     setGelActiveLane
//   }
// )(GelPipette);